//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Paul Roberts
 * Original Team: Mavericks
 */
import { VSelect } from 'vuetify/lib';
import { NsIcon } from '@nuskin/ns-icon';

export default {
  name: 'NsSelect',
  components: { NsIcon, VSelect },
  props: {
    value: {
      type: [String, Boolean, Number, Object],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },

    items: {
      type: Array,
      default: () => [],
    },
    itemText: {
      type: String,
      default: 'text',
    },
    itemValue: {
      type: String,
      default: 'value',
    },
    validateOnBlur: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    errorMessages: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: '',
    },
    menuProps: {
      type: [String, Object],
      default: 'auto',
    },
    rules: {
      type: Array,
      default: () => [],
    },
    /**
     * This will enable or disable left and right arrows which allow the user to
     * navigate trough the items in the select box
     */
    hasArrows: {
      type: Boolean,
      default: false,
    },
    reverseArrowControls: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputValue: this.value,
      autoCompleteValue: null,
    };
  },
  computed: {
    arrowClassesLeft() {
      const classes = ['arrow-class', 'ns-select-arrow-left'];
      if (
        !this.reverseArrowControls
          ? this.currItemIndex <= 0
          : this.currItemIndex >= this.items.length - 1
      ) {
        classes.push('hidden-arrow');
      }
      return classes;
    },
    arrowClassesRight() {
      const classes = ['arrow-class', 'ns-select-arrow-right'];
      if (
        !this.reverseArrowControls
          ? this.currItemIndex >= this.items.length - 1
          : this.currItemIndex <= 0
      ) {
        classes.push('hidden-arrow');
      }
      return classes;
    },
    currItemIndex() {
      return this.items.findIndex((el) => {
        return (
          el === this.inputValue ||
          el.text === this.inputValue ||
          el.value === this.inputValue
        );
      });
    },
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.inputValue = this.value;
        this.autoCompleteValue = this.value;
      }
      if (!newVal) {
        this.autoCompleteValue = '';
      }
    },
    autoCompleteValue(newVal) {
      if (newVal && this.items.length > 0 && newVal !== this.inputValue) {
        const found = this.items.find((el) => {
          return el === newVal || el.text === newVal || el.value === newVal;
        });
        if (found) {
          this.value = this.inputValue = found.value ? found.value : found;
          this.selectChanged();
        }
      }
    },
  },
  methods: {
    previous() {
      if (this.currItemIndex > 0) {
        const i = this.currItemIndex - 1;
        this.inputValue = this.items[i].value
          ? this.items[i].value
          : this.items[i];
        this.selectChanged();
      }
    },
    next() {
      if (this.currItemIndex < this.items.length - 1) {
        const i = this.currItemIndex + 1;
        this.inputValue = this.items[i].value
          ? this.items[i].value
          : this.items[i];
        this.selectChanged();
      }
    },
    selectChanged() {
      this.$emit('input', this.inputValue);
    },
  },
};
